const STORAGE_KEY = '3dmeet.avatar-selection.v1';
const AVATAR_ID_PARAM = 'avatar_id';
const SKIN_TONE_PARAM = 'skin_tone';

const resolveWindow = (browserWindow) => {
  if (browserWindow) return browserWindow;
  return typeof window === 'undefined' ? null : window;
};

const normalizeSelection = (avatarId, skinTone) => {
  if (typeof avatarId !== 'string' || !avatarId || avatarId.length > 128) {
    return null;
  }

  return {
    avatarId,
    skinTone:
      typeof skinTone === 'string' && skinTone.length <= 64
        ? skinTone || null
        : null,
  };
};

const writeSelectionToUrl = (browserWindow, url, selection) => {
  url.searchParams.set(AVATAR_ID_PARAM, selection.avatarId);
  if (selection.skinTone) {
    url.searchParams.set(SKIN_TONE_PARAM, selection.skinTone);
  } else {
    url.searchParams.delete(SKIN_TONE_PARAM);
  }
  browserWindow.history.replaceState({}, '', url.toString());
};

const storeSelection = (browserWindow, selection) => {
  try {
    browserWindow.sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(selection),
    );
  } catch (error) {
    console.warn('[marcus] avatar session persistence unavailable', error);
  }
};

export const readAvatarSelection = (providedWindow) => {
  const browserWindow = resolveWindow(providedWindow);
  if (!browserWindow) return null;

  try {
    const url = new URL(browserWindow.location.href);
    const urlSelection = normalizeSelection(
      url.searchParams.get(AVATAR_ID_PARAM),
      url.searchParams.get(SKIN_TONE_PARAM),
    );

    // URL persistence is intentional: it survives refreshes and lets a copied
    // meeting URL carry the chosen avatar. Session storage is only a fallback
    // for the short-lived release that temporarily removed these parameters.
    if (urlSelection) {
      storeSelection(browserWindow, urlSelection);
      return urlSelection;
    }

    const stored = browserWindow.sessionStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    return normalizeSelection(parsed?.avatarId, parsed?.skinTone);
  } catch (error) {
    console.warn('[marcus] readAvatarSelection failed', error);
    return null;
  }
};

export const persistAvatarSelection = (avatarId, skinTone, providedWindow) => {
  const browserWindow = resolveWindow(providedWindow);
  if (!browserWindow) return;

  const selection = normalizeSelection(avatarId, skinTone);
  if (!selection) return;

  storeSelection(browserWindow, selection);

  try {
    // Preserve the meeting token and unrelated parameters while adding the
    // non-secret opaque avatar ID and skin tone selected for this experience.
    writeSelectionToUrl(
      browserWindow,
      new URL(browserWindow.location.href),
      selection,
    );
  } catch (error) {
    console.warn('[marcus] avatar URL persistence failed', error);
  }
};

export const AVATAR_SELECTION_STORAGE_KEY = STORAGE_KEY;
